import { SaveResult } from "../../shared/models/result.model";
import { ActivityInfo } from "../calendars/calendars.models";

export class ContactsReplacer
{
  public StartDate: Date
  public EndDate: Date;
  public StationIds: number[] = [];
  public ClientIds: number[] = [];
  public FromClientExecId: number = 0;
  public ToClientExecId: number = 0;
  public FromClientSupportId: number = 0;
  public ToClientSupportId: number = 0;
  public FromBriefManagerId: number = 0;
  public ToBriefManagerId: number = 0;
  public FromProjectManagerId: number = 0;
  public ToProjectManagerId: number = 0;
  public FromNatProjectManagerId: number = 0;
  public ToNatProjectManagerId: number = 0;
  public FromProgrammerId: number = 0;
  public ToProgrammerId: number = 0;
  public FromAdOpsId: number = 0;
  public ToAdOpsId: number = 0;
  public UpdatePropertyContacts: boolean = false;
  public ChangedByUserId = 0;
}


export class PropertyInfoCopier
{
  public StationIds: number[] = [];
  public PropertyTypeIds: number[] = [];
  public PropertyId: number = 0;
  public FromStationId: number = 0;
  public ToPropertyIds: number[] = [];
  public CopyExclusionDates: boolean = false;
  public CopyAirtimeCredit: boolean = false;
  public CopySpotsAvailable: boolean = false;
  public CopyProjectManager: boolean = false;
  public ChangedByUserId = 0;
}


export class ActivityInfoCopier
{
  public ActivityId: number = 0;
  public ToActivityIds: number[] = [];
  public CopyCreditLines: boolean = false;
  public ChangedByUserId = 0;
}


export class ActivitiesList
{
  public Id: number = 0;
  public Name: string = "";
}

export class ActivityListGetParameters
{
  public PropertyIds: number[] = [];
  public StationIds: number[] = [];
  public StartDate: Date
  public EndDate: Date;
}

export class ProgressActivitiesInfo
{
  public CampaignId: number = 0;
  public SelectedActivities: ActivityInfo[] = [];
  public ActivityIds: number[] = [];
  public Status = "";

  // Existing
  public CreditLine = "";
  public CreditLineDueDate: Date;
  public HeldDate: Date;

  // NEW: Activity-level fields
  public Product?: string;
  public BookingId?: string;
  public Scripts?: number;
  public ClientExecUserId?: number;
  public ClientSupportUserId?: number;
  public BriefManagerUserId?: number;
  public ProgrammerUserId?: number;
  public MechanicTypeId?: number;
  public MajorPrize?: string;
  public MajorPrizeHowFulFilled?: string;
  public MinorPrize?: string;
  public MinorPrizeHowFulFilled?: string;

  // NEW: Station-specific (applied uniformly)
  public ActivityName?: string;
  public Mechanic?: string;
  public AirtimeBreakdown?: string;
  public Revenue?: number;
  public Production?: number;
  public MultimediaRecovery?: number;
  public OnAirTime?: Date;
  public StartTime?: Date;
  public EndTime?: Date;
  public OnsiteContactName?: string;
  public OnsiteContactTel?: string;
  public TicketingOutlet?: string;
  public LocationAddress?: string;
  public SignageRequired?: string;

  public ChangedByUserId = 0;
  public SaveResult: SaveResult;
}
